import {createSelector} from "reselect";
import {State} from "../reducers";

export const processInProgress = createSelector((state: State) => state.workflow,
    workflow => workflow.processInProgress)
